import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap";

export default class extends Controller {
  connect() {

  }

  click(event) {
    // Your logic here
    console.log("Revision status radio clicked!", event.target)

    const revisionId = event.target.dataset.revisionId;
    const status = event.target.dataset.status;
    const isActive = status === "true";
    const wasActive = event.target.dataset.active === true;
    event.preventDefault();
    event.stopPropagation();
    if (event.target.checked === wasActive) {
      return;
    }
    const modalId = isActive
      ? `revision-status-${revisionId}-active`
      : `revision-status-${revisionId}-inactive`;
    const modal = new bootstrap.Modal(document.getElementById(modalId), {
      backdrop: false,
    });
    modal.show();

  }
}
